module.exports = __webpack_public_path__ + "static/img/ms.719ebc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wz/ms.png
// module id = VGe+
// module chunks = 1